import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '../store';

export type NotificationType = 'error' | 'warning' | 'info' | 'success';

export interface NotificationState {
  open: boolean;
  message: string;
  type: NotificationType;
  duration?: number;
}

const initialState: NotificationState = {
  open: false,
  message: '',
  type: 'info',
  duration: 6000, // Default duration in milliseconds
};

export const notificationSlice = createSlice({
  name: 'notification',
  initialState,
  reducers: {
    showNotification: (state, action: PayloadAction<Omit<NotificationState, 'open'>>) => {
      state.open = true;
      state.message = action.payload.message;
      state.type = action.payload.type;
      state.duration = action.payload.duration ?? 6000; // Use default if not provided
    },
    hideNotification: state => {
      state.open = false;
    },
  },
});

export const { showNotification, hideNotification } = notificationSlice.actions;

export const selectNotification = (state: RootState) => state.notification;

export default notificationSlice.reducer;
